import { useState } from 'react';
import {
  DEFAULT_RULE_FILE,
  CODE_REVIEW_RULE_FILE,
  PR_DESCRIPTION_RULE_FILE,
  PR_DESCRIPTION_ADVANCED_RULE_FILE,
  LINEARB_AI_RULE_FILE
} from '../conts';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';

export const SelectRulesFile = ({ setRuleFile }) => {
  const [selectedFile, setSelectedFile] = useState(DEFAULT_RULE_FILE);

  const handleFileChange = event => {
    const newFile = event.target.value;
    setSelectedFile(newFile);
    setRuleFile(newFile);
  };

  return (
    <FormControl fullWidth variant='outlined'>
      <InputLabel id='select-rule-file-label'>CM Rule File</InputLabel>
      <Select
        fullWidth
        labelId='select-rule-file-label'
        value={selectedFile}
        onChange={handleFileChange}
        label='Rule File'
      >
        <MenuItem value={DEFAULT_RULE_FILE}>Default</MenuItem>
        <MenuItem value={PR_DESCRIPTION_RULE_FILE}>Describe Changes</MenuItem>
        <MenuItem value={PR_DESCRIPTION_ADVANCED_RULE_FILE}>
          Describe Changes - Advanced
        </MenuItem>
        <MenuItem value={CODE_REVIEW_RULE_FILE}>Code Review</MenuItem>
        <MenuItem value={LINEARB_AI_RULE_FILE}>LinearB AI</MenuItem>
      </Select>
    </FormControl>
  );
};

export default SelectRulesFile;
